import ic_correo from './Recursos/ic_mail.svg'
import ic_telefono from './Recursos/ic_telefono.svg'
import ic_direccion from './Recursos/ic_direccion.svg'
export const NEGRITA = "DM Serif Text"

export const SECCIONES = ['Pensum', 'Docentes', 'Contactos', 'Nosotros']

export const WASS = '3015243727'

export const CONTACTOS = [
    {
        nombre:'Telefono',
        descripcion: '+57 301 524 3727',
        img: ic_telefono,
        url: `https://api.whatsapp.com/send?phone=57${WASS}`
    },
    {
        nombre:'Correo',
        descripcion: 'soluciondeconflictosparalapazc@gmail.com',
        img: ic_correo,
        url: 'mailto:soluciondeconflictosparalapazc@gmail.com'
    },
    {
        nombre:'Direccion',
        descripcion: 'Calle 14 #7-15  piso 3 Ipiales - Nariño',
        img: ic_direccion,
        url: `https://www.google.com/maps/dir/?api=1&destination=${0.8250191090320209},${-77.63980343141678},190&dir_action=navigate`
    },

]

export const TIPOSESTUDIANTES = ['Abogado u otro Profesional graduado', 'Estudiante de pregrado']

export const DIPLOMADO= {

}

